// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fcd9e6c7","177":"41e69d1a","288":"8e26e5ea","480":"676699e0","972":"983c3ed4"}[chunkId] + ".chunk.js";
};